var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.068 0A2.934 2.934 0 0 1 24 2.932v18.136A2.934 2.934 0 0 1 21.068 24h-4.99v-9.043h3.121l.594-3.873h-3.716V8.571c0-1.06.52-2.092 2.183-2.092h1.69V3.18s-1.533-.261-3-.261c-3.06 0-5.06 1.855-5.06 5.212v2.952H8.488v3.873h3.402V24H2.932A2.934 2.934 0 0 1 0 21.068V2.932A2.934 2.934 0 0 1 2.932 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFacebook;